<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g stroke="currentColor" style="opacity:.8"><path d="M459 28.464v11" style="fill:none;stroke-linecap:round;stroke-width:2px" transform="translate(-451.001 -25.964)" fill="currentColor"/><path d="M0 0v11" style="fill:none;stroke-linecap:round;stroke-width:2px" transform="rotate(90 2.75 10.75)" fill="currentColor"/></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-add-sm',
});
</script>
